import Paginator from '../../../components/Paginator'
import { useQsFilters } from '../../../hooks/filters'
import { useNotificaList, useReadNotifica } from '../../../hooks/notifica'
import AvvisiTable from './AvvisiTable'

const initFilters = (params: URLSearchParams) => ({
  page: Number(params.get('page') ?? 1),
  search: params.get('search') ?? '',
  ordering: params.get('ordering') ?? 'letta',
})

export default function AvvisiCliente() {
  const { filters, uiFilters, setFilters } = useQsFilters(initFilters)
  const notifiche = useNotificaList({
    search: filters.search,
    ordering: filters.ordering,
    page: String(filters.page),
  })

  const { mutateAsync: readNotifica } = useReadNotifica()
  const handleReadClick = async (notificaId: number) => {
    await readNotifica({ notificaId: notificaId, letta: true }).then(() => {
      notifiche.refetch()
    })
  }
  return (
    <div className="page">
      <div className="row mt-4">
        <div className="col-12 d-flex justify-content-between">
          <h1 className="title">Avvisi</h1>
        </div>
        <div className="col-12">
          <div className="flex-1 d-flex flex-column overflow-hidden">
            <div className="bg-white p-2 border-bottom d-flex justify-content-between align-items-center w-100 rounded">
              <div className="d-flex align-items-center">
                <div className="ms-2 position-relative">
                  <input
                    type="text"
                    style={{ width: '300px', paddingLeft: '40px' }}
                    className="form-control"
                    placeholder="Cerca avviso..."
                    value={uiFilters.search}
                    onChange={(e) => setFilters({ search: e.target.value, page: 1 })}
                  />
                  <span className="position-absolute material-icons" style={{ left: '10px', top: '8px' }}>
                    search
                  </span>
                </div>
              </div>
              <div className="me-2">
                Stai visualizzando {notifiche?.data?.count ?? 0} di {notifiche?.data?.full_count ?? 0} avvisi
              </div>
            </div>
            <AvvisiTable
              notifiche={notifiche}
              uiFilters={uiFilters}
              setFilters={setFilters}
              handleReadClick={handleReadClick}
            />
            <div className="position-relative">
              <Paginator
                count={notifiche?.data?.count ?? 0}
                currentPage={uiFilters.page}
                goToPage={(page) => setFilters({ page })}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
